const misInformesInitialState = {
    misInformes: {
      loading: false,
      error: null,
      data: null,
      archivobase64: null,      
      visualizarimagen: null,      
    },
  };
  
  export default misInformesInitialState;
  